export default __webpack_public_path__ + "static/media/trash_gray.44cca7e1.svg";